var _path, _path2, _g, _g2, _g3, _g4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormulary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 86,
    viewBox: "0 0 98 86",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0h98v86h-98z",
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3012,0L89.6988,0C94.2834,0 98,3.7166 98,8.3012L98,86.9763L98,86.9763L47.5053,86.9763L0,86.9763L0,8.3012C-0,3.7166 3.7166,-0 8.3012,0Z",
    strokeWidth: 1,
    fill: "#F4F5F7",
    fillRule: "evenodd",
    stroke: "#00000000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,12l48,0l0,62l-48,0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.6388,18.9198L67.3101,18.9198C70.4529,18.9198 73,21.4767 73,24.6298L73,68.2908C73,71.4439 70.4529,74 67.3101,74L30.6388,74C27.4968,74 24.9497,71.4439 24.9497,68.2908L24.9497,24.6298C24.9497,21.4767 27.4968,18.9198 30.6388,18.9198",
    strokeWidth: 1,
    fill: "#BBC0C4",
    fillRule: "evenodd",
    stroke: "#00000000"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,12l48,0l0,62l-48,0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.4657,19.1788L62.0718,19.1788L62.0718,21.5423C62.0718,23.319 60.6366,24.7593 58.867,24.7593L38.6839,24.7593C36.9135,24.7593 35.4782,23.319 35.4782,21.5423L35.4782,19.1788L35.4657,19.1788",
    strokeWidth: 1,
    fill: "#9EA6AE",
    fillRule: "evenodd",
    stroke: "#00000000"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,12l48,0l0,62l-48,0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.867,15.9617L55.5843,15.9617C54.2731,15.9331 53.0774,15.1974 52.4566,14.0371C51.3741,12.1116 48.9401,11.4305 47.0206,12.5177C46.3871,12.8759 45.8635,13.4014 45.5057,14.0371C44.8865,15.1999 43.6909,15.9357 42.378,15.9617L39.1087,15.9617C37.283,15.7835 35.6584,17.1229 35.4799,18.9551C35.4732,19.0291 35.4682,19.1039 35.4657,19.1788L35.4657,20.2643C35.4657,21.1623 36.1921,21.8913 37.0878,21.8913L60.4506,21.8913C61.3429,21.8845 62.0643,21.1597 62.0719,20.2643L62.0719,19.1788C62.0785,17.4096 60.6558,15.9693 58.8922,15.9617C58.8838,15.9617 58.8754,15.9617 58.867,15.9617",
    strokeWidth: 1,
    fill: "#E98799",
    fillRule: "evenodd",
    stroke: "#00000000"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,12l48,0l0,62l-48,0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.4566,14.0371C51.3741,12.1116 48.9401,11.4305 47.0206,12.5177C46.3871,12.8759 45.8635,13.4014 45.5057,14.0371C44.8865,15.1999 43.6909,15.9357 42.378,15.9617L55.5843,15.9617C54.2731,15.9331 53.0774,15.1974 52.4566,14.0371",
    strokeWidth: 1,
    fill: "#E25D6F",
    fillRule: "evenodd",
    stroke: "#00000000"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8766,42.2494L36.1091,39.4587C35.4053,38.7793 35.2864,37.6921 35.8268,36.8757C36.4476,35.9878 37.6676,35.7734 38.5523,36.3973C38.6453,36.4628 38.7325,36.536 38.8129,36.6167L39.7647,37.5601L43.7295,33.5948C44.4056,32.8885 45.4856,32.764 46.3034,33.2971C47.189,33.9319 47.3942,35.1654 46.7625,36.0542C46.6988,36.1442 46.6268,36.2291 46.548,36.3073L40.6143,42.2494C40.1233,42.701 39.3693,42.701 38.8766,42.2494",
    strokeWidth: 1,
    fill: "#FFFFFE",
    fillRule: "evenodd",
    stroke: "#00000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.925,35.2991l11.1343,0l0,-1.537l-11.1343,0z",
    strokeWidth: 1,
    fill: "#9EA6AE",
    fillRule: "evenodd",
    stroke: "#00000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.925,38.5414l11.1343,0l0,-1.537l-11.1343,0z",
    strokeWidth: 1,
    fill: "#9EA6AE",
    fillRule: "evenodd",
    stroke: "#00000000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.925,41.7836l5.5734,0l0,-1.537l-5.5734,0z",
    strokeWidth: 1,
    fill: "#9EA6AE",
    fillRule: "evenodd",
    stroke: "#00000000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8766,59.6361L36.1091,56.8462C35.4053,56.1668 35.2864,55.0788 35.8268,54.2624C36.4476,53.3745 37.6676,53.1609 38.5523,53.7839C38.6453,53.8495 38.7325,53.9235 38.8129,54.0042L39.7647,54.9594L43.7295,50.9814C44.4056,50.2752 45.4856,50.1507 46.3034,50.6838C47.189,51.3178 47.3942,52.553 46.7625,53.4417C46.6988,53.5308 46.6268,53.6158 46.548,53.694L40.6143,59.6361C40.1233,60.0876 39.3693,60.0876 38.8766,59.6361",
    strokeWidth: 1,
    fill: "#FFFFFE",
    fillRule: "evenodd",
    stroke: "#00000000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.925,52.6858l11.1343,0l0,-1.537l-11.1343,0z",
    strokeWidth: 1,
    fill: "#9EA6AE",
    fillRule: "evenodd",
    stroke: "#00000000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.925,55.9289l11.1343,0l0,-1.537l-11.1343,0z",
    strokeWidth: 1,
    fill: "#9EA6AE",
    fillRule: "evenodd",
    stroke: "#00000000"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M50.925,59.1711l5.5734,0l0,-1.537l-5.5734,0z",
    strokeWidth: 1,
    fill: "#9EA6AE",
    fillRule: "evenodd",
    stroke: "#00000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormulary);
export default __webpack_public_path__ + "static/media/formulary.b0f6fbac31b0ff8d5abef2b6fdbcd6d7.svg";
export { ForwardRef as ReactComponent };